export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-white">
      {/* Main footer */}
      <div className="w-full px-4 md:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          {/* Brand column */}
          <div className="lg:col-span-4">
            <h2 className="text-3xl md:text-4xl font-bold font-heading mb-6">
              <span>Galore</span>
              <span className="text-accent-400">Store</span>
            </h2>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-sm mb-8">
              {t("footer.description")}
            </p>
            <div className="flex items-center gap-3">
              {["facebook", "twitter", "instagram", "youtube"].map((social) => (
                <a
                  key={social}
                  href={`https://${social}.com`}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-300 hover:text-white hover:border-accent-400 transition-colors cursor-pointer"
                  aria-label={social}
                >
                  <i className={`ri-${social}-${social === "youtube" ? "fill" : "line"}`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Shop links */}
          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">
              {t("footer.shop")}
            </h4>
            <div className="flex flex-col gap-3">
              {["footer.all_products", "footer.new_arrivals", "footer.best_sellers", "footer.deals_footer"].map((key) => (
                <Link
                  key={key}
                  to="/products"
                  className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  {t(key)}
                </Link>
              ))}
            </div>
          </div>

          {/* Company links */}
          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">
              {t("footer.company")}
            </h4>
            <div className="flex flex-col gap-3">
              {["footer.about_us", "footer.careers", "footer.contact", "footer.blog"].map((key) => (
                <a
                  key={key}
                  href="#"
                  className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  {t(key)}
                </a>
              ))}
            </div>
          </div>

          {/* Support links */}
          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">
              {t("footer.support")}
            </h4>
            <div className="flex flex-col gap-3">
              {["footer.help_center", "footer.shipping", "footer.returns", "footer.faq"].map((key) => (
                <a
                  key={key}
                  href="#"
                  className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  {t(key)}
                </a>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">
              {t("footer.contact")}
            </h4>
            <div className="flex flex-col gap-4">
              <div>
                <p className="text-xs text-foreground-500 mb-1">{t("footer.address_title")}</p>
                <p className="text-sm text-foreground-300">{t("footer.address_line1")}</p>
                <p className="text-sm text-foreground-300">{t("footer.address_line2")}</p>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-1">{t("footer.phone_title")}</p>
                <p className="text-sm text-foreground-300">{t("footer.phone")}</p>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-1">{t("footer.email_title")}</p>
                <a href="mailto:hello@generalstore.com" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">
                  {t("footer.email")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
              {t("footer.privacy")}
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
              {t("footer.terms")}
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
              {t("footer.cookies")}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}